import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeNewsComponent } from 'src/app/components/home/home-news/home-news.component';
import { HomeWorkPrioritiesComponent } from 'src/app/components/home/home-work-priorities/home-work-priorities.component';
import { HomeBussinessLogicService } from 'src/app/services/home-bussiness-logic.service';




@NgModule({
  declarations: [HomeNewsComponent,HomeWorkPrioritiesComponent],
  imports: [
    CommonModule,
    
  ],
  providers:[HomeBussinessLogicService]
})
export class HomeModule { }
